import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ctm-components';

import styles from './display_toggle.css';

/*
    Display Mode (Quick Price / Features) Button Toggle Component
 */
class DisplayToggle extends PureComponent {

    constructor(props) {
        super(props);
        this.buttons = [
            {
                label: 'Quick Price',
                view: 'row',
                icon: 'ctm_quick_view',
                iconPosition: 'before'
            },
            {
                label: 'Features View',
                view: 'column',
                icon: 'ctm_feature_view',
                iconPosition: 'before'
            }
        ];
    }

    /**
     * Handles clicking on a button
     * @param {Event} event The elements event object
     * @param {String} view The view of the result
     */
    handleClick = (event, view) => {
        const { displayMode, setResultsConfigValue, previousDisplayMode } = this.props;
        if (displayMode !== view) {
            // Set Display Mode
            setResultsConfigValue(view, 'displayMode');

            // Set Previous Display mode
            if (displayMode !== previousDisplayMode) {
                setResultsConfigValue(view, 'previousDisplayMode');
            }
        }
    };

    /**
     * Returns the Button UI Component
     * @param {string} view The Display Mode View
     * @returns {string} Button UIComponent
     */
    getButtonUIComponent = (view) => {
        const { displayMode, UIComponentActive, UIComponent } = this.props;
        return displayMode === view ? UIComponentActive : UIComponent;
    };

    /**
     * Builds each of the Toggle Buttons from buttonProps
     * @returns {Array} An array of tab buttons.
     */
    getToggleButtons = () => {
        return this.buttons.map((obj) => (
            <Button
                className={styles.button}
                label={obj.label}
                icon={obj.icon}
                iconPosition={obj.iconPosition}
                onClickFunction={(event) => this.handleClick(event, obj.view)}
                key={obj.view}
                UIComponent={this.getButtonUIComponent(obj.view)}
            />
        ));
    };

    /**
     * Render the Display Toggle Buttons
     * @returns {Node} - Returns the Display Toggle Component
     */
    render = () => {
        const { containerClass } = this.props;
        return <div className={styles[containerClass]}>{this.getToggleButtons()}</div>;
    };

}

DisplayToggle.propTypes = {
    displayMode: PropTypes.string,
    previousDisplayMode: PropTypes.string,
    containerClass: PropTypes.string,
    UIComponent: PropTypes.string,
    UIComponentActive: PropTypes.string,
    setResultsConfigValue: PropTypes.func.isRequired
};

export { DisplayToggle };
